<template>
  <div class="nutech">
    <div class="categoryStatus">
      <div class="totalPresence">
        <img src="../assets/green.jpg" />
        <p>
          <span class="font-weight-bold">Total:</span>
          {{totalPresence}}
        </p>
      </div>
      <div class="totalLeft">
        <img src="../assets/white.jpg" />
        <p>
          <span class="font-weight-bold">Total:</span>
          {{totalAbsence}}
        </p>
      </div>
      <div class="totalPanic">
        <img src="../assets/red.jpg" />
        <p>
          <span class="font-weight-bold">Total:</span>
          {{totalPanic}}
        </p>
      </div>
    </div>
    <div class="mapcontroller">
      <!-- ground red -->
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag001gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag002gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag003gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag004gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag005gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag006gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag007gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag008gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag009gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag010gred" />
      <img src="../assets/gred.png" class="mapcontrollerg" id="tag011gred" />

      <!-- ground blue -->
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag001gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag002gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag003gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag004gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag005gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag006gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag007gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag008gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag009gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag010gblue" />
      <img src="../assets/gblue.png" class="mapcontrollerg" id="tag011gblue" />

      <!-- first red -->
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag001f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag002f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag003f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag004f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag005f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag006f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag007f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag008f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag009f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag010f1red" />
      <img src="../assets/f1red.png" class="mapcontrollerf1" id="tag011f1red" />

      <!-- first blue -->
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag001f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag002f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag003f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag004f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag005f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag006f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag007f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag008f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag009f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag010f1blue" />
      <img src="../assets/f1blue.png" class="mapcontrollerf1" id="tag011f1blue" />
    </div>
    <div class="floorplan">
      <img src="../assets/Nutech00.png" class="floorplan0" id="floorplan0" />
      <img src="../assets/Nutech01.png" class="floorplan1" id="floorplan1" />
      <!-- tag001 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag001"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag001"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag001"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag001"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag001"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag001"
      />
      <!-- tag002 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag002"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag002"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag002"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag002"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag002"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag002"
      />
      <!-- tag003 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag003"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag003"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag003"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag003"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag003"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag003"
      />
      <!-- tag004 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag004"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag004"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag004"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag004"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag004"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag004"
      />
      <!-- tag005 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag005"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag005"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag005"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag005"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag005"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag005"
      />
      <!-- tag006 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag006"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag006"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag006"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag006"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag006"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag006"
      />
      <!-- tag007 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag007"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag007"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag007"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag007"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag007"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag007"
      />
      <!-- tag008 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag008"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag008"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag008"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag008"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag008"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag008"
      />
      <!-- tag009 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag009"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag009"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag009"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag009"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag009"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag009"
      />
      <!-- tag010 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag010"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag010"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag010"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag010"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag010"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag010"
      />

      <!-- tag011 panic -->
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicreception"
        id="panicreceptiontag011"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicguardsoffice"
        id="panicguardsofficetag011"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panictechnicaldepartment"
        id="panictechnicaldepartmenttag011"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panichroffice"
        id="panichrofficetag011"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicconferenceroom"
        id="panicconferenceroomtag011"
      />
      <img
        src="../assets/red.jpg"
        class="floorplanmarkeranimation panicsalesoffice"
        id="panicsalesofficetag011"
      />
    </div>

    <div class="staffstatus">
      <div class="tag001div">
        <img src="../assets/tag001/white.jpg" class="staff tag001" id="tag001white" />
        <img src="../assets/tag001/green.jpg" class="staff tag001" id="tag001green" />
        <img src="../assets/tag001/red.jpg" class="staff tag001" id="tag001red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag001.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag001Room">{{ tag001.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag001.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag001">
          <v-btn class="error" height="74" @click="cancelPanicTag001">Checked</v-btn>
        </div>
      </div>
      <div class="tag002div">
        <img src="../assets/tag002/green.jpg" class="staff tag001" id="tag002green" />
        <img src="../assets/tag002/white.jpg" class="staff tag001" id="tag002white" />
        <img src="../assets/tag002/red.jpg" class="staff tag001" id="tag002red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag002.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag002Room">{{ tag002.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag002.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag002">
          <v-btn class="error" height="74" @click="cancelPanicTag002">Checked</v-btn>
        </div>
      </div>
      <div class="tag003div">
        <img src="../assets/tag003/green.jpg" class="staff tag001" id="tag003green" />
        <img src="../assets/tag003/white.jpg" class="staff tag001" id="tag003white" />
        <img src="../assets/tag003/red.jpg" class="staff tag001" id="tag003red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag003.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag003Room">{{ tag003.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag003.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag003">
          <v-btn class="error" height="74" @click="cancelPanicTag003">Checked</v-btn>
        </div>
      </div>
      <div class="tag004div">
        <img src="../assets/tag004/green.jpg" class="staff tag001" id="tag004green" />
        <img src="../assets/tag004/white.jpg" class="staff tag001" id="tag004white" />
        <img src="../assets/tag004/red.jpg" class="staff tag001" id="tag004red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag004.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag004Room">{{ tag004.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag004.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag004">
          <v-btn class="error" height="74" @click="cancelPanicTag004">Checked</v-btn>
        </div>
      </div>
      <div class="tag005div">
        <img src="../assets/tag005/green.jpg" class="staff tag001" id="tag005green" />
        <img src="../assets/tag005/white.jpg" class="staff tag001" id="tag005white" />
        <img src="../assets/tag005/red.jpg" class="staff tag001" id="tag005red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag005.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag005Room">{{ tag005.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag005.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag005">
          <v-btn class="error" height="74" @click="cancelPanicTag005">Checked</v-btn>
        </div>
      </div>
      <div class="tag006div">
        <img src="../assets/tag006/green.jpg" class="staff tag001" id="tag006green" />
        <img src="../assets/tag006/white.jpg" class="staff tag001" id="tag006white" />
        <img src="../assets/tag006/red.jpg" class="staff tag001" id="tag006red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag006.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag006Room">{{ tag006.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag006.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag006">
          <v-btn class="error" height="74" @click="cancelPanicTag006">Checked</v-btn>
        </div>
      </div>
      <div class="tag007div">
        <img src="../assets/tag007/green.jpg" class="staff tag001" id="tag007green" />
        <img src="../assets/tag007/white.jpg" class="staff tag001" id="tag007white" />
        <img src="../assets/tag007/red.jpg" class="staff tag001" id="tag007red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag007.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag007Room">{{ tag007.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag007.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag007">
          <v-btn class="error" height="74" @click="cancelPanicTag007">Checked</v-btn>
        </div>
      </div>
      <div class="tag008div">
        <img src="../assets/tag008/green.jpg" class="staff tag001" id="tag008green" />
        <img src="../assets/tag008/white.jpg" class="staff tag001" id="tag008white" />
        <img src="../assets/tag008/red.jpg" class="staff tag001" id="tag008red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag008.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag008Room">{{ tag008.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag008.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag008">
          <v-btn class="error" height="74" @click="cancelPanicTag008">Checked</v-btn>
        </div>
      </div>
      <div class="tag009div">
        <img src="../assets/tag009/green.jpg" class="staff tag001" id="tag009green" />
        <img src="../assets/tag009/white.jpg" class="staff tag001" id="tag009white" />
        <img src="../assets/tag009/red.jpg" class="staff tag001" id="tag009red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag009.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag009Room">{{ tag009.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag009.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag009">
          <v-btn class="error" height="74" @click="cancelPanicTag009">Checked</v-btn>
        </div>
      </div>
      <div class="tag010div">
        <img src="../assets/tag010/green.jpg" class="staff tag001" id="tag010green" />
        <img src="../assets/tag010/white.jpg" class="staff tag001" id="tag010white" />
        <img src="../assets/tag010/red.jpg" class="staff tag001" id="tag010red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag010.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag010Room">{{ tag010.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag010.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag010">
          <v-btn class="error" height="74" @click="cancelPanicTag010">Checked</v-btn>
        </div>
      </div>
      <div class="tag011div">
        <img src="../assets/tag011/green.jpg" class="staff tag001" id="tag011green" />
        <img src="../assets/tag011/white.jpg" class="staff tag001" id="tag011white" />
        <img src="../assets/tag011/red.jpg" class="staff tag001" id="tag011red" />
        <div class="tagtext">
          <p class="ma-0">
            <span class="font-weight-bold">Name:</span>
            {{ tag011.name }}
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Room:</span>
            <span id="tag010Room">{{ tag011.room }}</span>
          </p>
          <p class="ma-0">
            <span class="font-weight-bold">Floor:</span>
            {{ tag011.floor }}
          </p>
        </div>
        <div class="panicbutton" id="panicbuttontag011">
          <v-btn class="error" height="74" @click="cancelPanicTag011">Checked</v-btn>
        </div>
      </div>
    </div>
    <audio id="panicsound" loop>
      <source src="../assets/panicsound.wav" type="audio/wav" />Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDqo_a0SMLn9CFCozXh9vQAm1o1TkB6jSg",
  authDomain: "breadcrumb-nutech-client-dash.firebaseapp.com",
  databaseURL: "https://breadcrumb-nutech-client-dash.firebaseio.com",
  projectId: "breadcrumb-nutech-client-dash",
  storageBucket: "breadcrumb-nutech-client-dash.appspot.com",
  messagingSenderId: "67349341817",
  appId: "1:67349341817:web:ee462972b1531ceffa16a8",
  measurementId: "G-DN9WSYYRJV"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// Get a reference to the database service
var db = firebase.database();
var auth = firebase.auth();

export default {
  name: "Nutech",
  data() {
    return {
      panics: [],
      displayLE: null,
      recptionMaker: 0,
      guardsofficeMaker: 0,
      technicaldepartmentMaker: 0,
      hrofficeMaker: 0,
      conferenceroomMaker: 0,
      salesofficeMaker: 0,
      totalPresence: 0,
      totalAbsence: 0,
      totalPanic: 0,
      newOpen: 0,
      tag001Button: 0,
      tag002Button: 0,
      tag003Button: 0,
      tag004Button: 0,
      tag005Button: 0,
      tag006Button: 0,
      tag007Button: 0,
      tag008Button: 0,
      tag009Button: 0,
      tag010Button: 0,
      tag011Button: 0,
      tag001: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag002: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag003: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag004: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag005: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag006: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag007: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag008: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag009: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag010: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      tag011: {
        name: null,
        room: null,
        floor: null,
        presence: 0,
        panic: 0
      },
      authEmail: "admin@admin.com",
      authPass: "admin1234"
    };
  },
  created: function() {
    this.logIn().then(cred => {
      if (cred) {
        // listen to indoor location
        this.listenToIndoorLocation();

        // listen to panic status
        this.listenToPanicStatus();
      }
    });
  },
  methods: {
    logIn: function() {
      return auth.signInWithEmailAndPassword(this.authEmail, this.authPass);
    },
    listenToPanicStatus: function() {
      // using firebase database deal with panic
      // get data from firebase database
      auth.onAuthStateChanged(user => {
        if (user) {
          //
          var panicRef = db.ref("clientpanic");
          panicRef.on("value", snapshot => {
            var panic = snapshot.val();

            // tag001
            if (panic.tag001) {
              document.getElementById("tag001red").style.opacity = "1";
              document.getElementById("tag001green").style.opacity = "0";
              document.getElementById("tag001white").style.opacity = "0";
              document.getElementById("panicbuttontag001").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag001.panic += 1;
              this.tag001Button += 1;

              if (panic.tag001.room === "RECEPTION") {
                document.getElementById("panicreceptiontag001").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "none";
                document.getElementById("panichrofficetag001").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "none";
              } else if (panic.tag001.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag001").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "none";
                document.getElementById("panichrofficetag001").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "none";
              } else if (panic.tag001.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag001").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "block";
                document.getElementById("panichrofficetag001").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "none";
              } else if (panic.tag001.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag001").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "none";
                document.getElementById("panichrofficetag001").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "none";
              } else if (panic.tag001.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag001").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "none";
                document.getElementById("panichrofficetag001").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "none";
              } else if (panic.tag001.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag001").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag001"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag001"
                ).style.display = "none";
                document.getElementById("panichrofficetag001").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag001"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag001"
                ).style.display = "block";
              }

              // map controller
              if (this.tag001.panic > 0 && this.tag001.floor === "Ground") {
                document.getElementById("tag001gred").style.display = "block";
                document.getElementById("tag001f1red").style.display = "none";
              } else if (
                this.tag001.panic > 0 &&
                this.tag001.floor === "First"
              ) {
                document.getElementById("tag001f1red").style.display = "block";
                document.getElementById("tag001gred").style.display = "none";
              }
            }

            // tag002
            if (panic.tag002) {
              document.getElementById("tag002red").style.opacity = "1";
              document.getElementById("tag002green").style.opacity = "0";
              document.getElementById("tag002white").style.opacity = "0";
              document.getElementById("panicbuttontag002").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag002.panic += 1;
              this.tag002Button += 1;

              if (panic.tag002.room === "RECEPTION") {
                document.getElementById("panicreceptiontag002").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "none";
                document.getElementById("panichrofficetag002").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "none";
              } else if (panic.tag002.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag002").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "none";
                document.getElementById("panichrofficetag002").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "none";
              } else if (panic.tag002.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag002").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "block";
                document.getElementById("panichrofficetag002").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "none";
              } else if (panic.tag002.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag002").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "none";
                document.getElementById("panichrofficetag002").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "none";
              } else if (panic.tag002.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag002").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "none";
                document.getElementById("panichrofficetag002").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "none";
              } else if (panic.tag002.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag002").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag002"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag002"
                ).style.display = "none";
                document.getElementById("panichrofficetag002").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag002"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag002"
                ).style.display = "block";
              }

              // map controller
              if (this.tag002.panic > 0 && this.tag002.floor === "Ground") {
                document.getElementById("tag002gred").style.display = "block";
                document.getElementById("tag002gblue").style.display = "none";
                document.getElementById("tag002f1red").style.display = "none";
                document.getElementById("tag002f1blue").style.display = "none";
              } else if (
                this.tag002.panic > 0 &&
                this.tag002.floor === "First"
              ) {
                document.getElementById("tag002f1red").style.display = "block";
                document.getElementById("tag002f1blue").style.display = "none";
                document.getElementById("tag002gred").style.display = "none";
                document.getElementById("tag002gblue").style.display = "none";
              }
            }

            // tag003
            if (panic.tag003) {
              document.getElementById("tag003red").style.opacity = "1";
              document.getElementById("tag003green").style.opacity = "0";
              document.getElementById("tag003white").style.opacity = "0";
              document.getElementById("panicbuttontag003").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag003.panic += 1;
              this.tag003Button += 1;

              if (panic.tag003.room === "RECEPTION") {
                document.getElementById("panicreceptiontag003").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "none";
                document.getElementById("panichrofficetag003").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "none";
              } else if (panic.tag003.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag003").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "none";
                document.getElementById("panichrofficetag003").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "none";
              } else if (panic.tag003.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag003").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "block";
                document.getElementById("panichrofficetag003").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "none";
              } else if (panic.tag003.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag003").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "none";
                document.getElementById("panichrofficetag003").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "none";
              } else if (panic.tag003.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag003").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "none";
                document.getElementById("panichrofficetag003").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "none";
              } else if (panic.tag003.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag003").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag003"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag003"
                ).style.display = "none";
                document.getElementById("panichrofficetag003").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag003"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag003"
                ).style.display = "block";
              }

              // map controller
              if (this.tag003.panic > 0 && this.tag003.floor === "Ground") {
                document.getElementById("tag003gred").style.display = "block";
                document.getElementById("tag003gblue").style.display = "none";
                document.getElementById("tag003f1red").style.display = "none";
                document.getElementById("tag003f1blue").style.display = "none";
              } else if (
                this.tag003.panic > 0 &&
                this.tag003.floor === "First"
              ) {
                document.getElementById("tag003f1red").style.display = "block";
                document.getElementById("tag003f1blue").style.display = "none";
                document.getElementById("tag003gred").style.display = "none";
                document.getElementById("tag003gblue").style.display = "none";
              }
            }

            // tag004
            if (panic.tag004) {
              // panic.tag004
              document.getElementById("tag004red").style.opacity = "1";
              document.getElementById("tag004green").style.opacity = "0";
              document.getElementById("tag004white").style.opacity = "0";
              document.getElementById("panicbuttontag004").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag004.panic += 1;
              this.tag004Button += 1;

              if (panic.tag004.room === "RECEPTION") {
                document.getElementById("panicreceptiontag004").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "none";
                document.getElementById("panichrofficetag004").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "none";
              } else if (panic.tag004.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag004").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "none";
                document.getElementById("panichrofficetag004").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "none";
              } else if (panic.tag004.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag004").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "block";
                document.getElementById("panichrofficetag004").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "none";
              } else if (panic.tag004.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag004").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "none";
                document.getElementById("panichrofficetag004").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "none";
              } else if (panic.tag004.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag004").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "none";
                document.getElementById("panichrofficetag004").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "none";
              } else if (panic.tag004.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag004").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag004"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag004"
                ).style.display = "none";
                document.getElementById("panichrofficetag004").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag004"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag004"
                ).style.display = "block";
              }

              // map controller
              if (this.tag004.panic > 0 && this.tag004.floor === "Ground") {
                document.getElementById("tag004gred").style.display = "block";
                document.getElementById("tag004gblue").style.display = "none";
                document.getElementById("tag004f1red").style.display = "none";
                document.getElementById("tag004f1blue").style.display = "none";
              } else if (
                this.tag004.panic > 0 &&
                this.tag004.floor === "First"
              ) {
                document.getElementById("tag004f1red").style.display = "block";
                document.getElementById("tag004f1blue").style.display = "none";
                document.getElementById("tag004gred").style.display = "none";
                document.getElementById("tag004gblue").style.display = "none";
              }
            }

            // tag005
            if (panic.tag005) {
              // panic.tag005
              document.getElementById("tag005red").style.opacity = "1";
              document.getElementById("tag005green").style.opacity = "0";
              document.getElementById("tag005white").style.opacity = "0";
              document.getElementById("panicbuttontag005").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag005.panic += 1;
              this.tag005Button += 1;

              if (panic.tag005.room === "RECEPTION") {
                document.getElementById("panicreceptiontag005").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "none";
                document.getElementById("panichrofficetag005").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "none";
              } else if (panic.tag005.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag005").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "none";
                document.getElementById("panichrofficetag005").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "none";
              } else if (panic.tag005.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag005").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "block";
                document.getElementById("panichrofficetag005").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "none";
              } else if (panic.tag005.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag005").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "none";
                document.getElementById("panichrofficetag005").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "none";
              } else if (panic.tag005.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag005").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "none";
                document.getElementById("panichrofficetag005").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "none";
              } else if (panic.tag005.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag005").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag005"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag005"
                ).style.display = "none";
                document.getElementById("panichrofficetag005").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag005"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag005"
                ).style.display = "block";
              }

              // map controller
              if (this.tag005.panic > 0 && this.tag005.floor === "Ground") {
                document.getElementById("tag005gred").style.display = "block";
                document.getElementById("tag005gblue").style.display = "none";
                document.getElementById("tag005f1red").style.display = "none";
                document.getElementById("tag005f1blue").style.display = "none";
              } else if (
                this.tag005.panic > 0 &&
                this.tag005.floor === "First"
              ) {
                document.getElementById("tag005f1red").style.display = "block";
                document.getElementById("tag005f1blue").style.display = "none";
                document.getElementById("tag005gred").style.display = "none";
                document.getElementById("tag005gblue").style.display = "none";
              }
            }

            // tag006
            if (panic.tag006) {
              // panic.tag006
              document.getElementById("tag006red").style.opacity = "1";
              document.getElementById("tag006green").style.opacity = "0";
              document.getElementById("tag006white").style.opacity = "0";
              document.getElementById("panicbuttontag006").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag006.panic += 1;
              this.tag006Button += 1;

              if (panic.tag006.room === "RECEPTION") {
                document.getElementById("panicreceptiontag006").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "none";
                document.getElementById("panichrofficetag006").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "none";
              } else if (panic.tag006.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag006").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "none";
                document.getElementById("panichrofficetag006").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "none";
              } else if (panic.tag006.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag006").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "block";
                document.getElementById("panichrofficetag006").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "none";
              } else if (panic.tag006.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag006").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "none";
                document.getElementById("panichrofficetag006").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "none";
              } else if (panic.tag006.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag006").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "none";
                document.getElementById("panichrofficetag006").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "none";
              } else if (panic.tag006.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag006").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag006"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag006"
                ).style.display = "none";
                document.getElementById("panichrofficetag006").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag006"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag006"
                ).style.display = "block";
              }

              // map controller
              if (this.tag006.panic > 0 && this.tag006.floor === "Ground") {
                document.getElementById("tag006gred").style.display = "block";
                document.getElementById("tag006gblue").style.display = "none";
                document.getElementById("tag006f1red").style.display = "none";
                document.getElementById("tag006f1blue").style.display = "none";
              } else if (
                this.tag006.panic > 0 &&
                this.tag006.floor === "First"
              ) {
                document.getElementById("tag006f1red").style.display = "block";
                document.getElementById("tag006f1blue").style.display = "none";
                document.getElementById("tag006gred").style.display = "none";
                document.getElementById("tag006gblue").style.display = "none";
              }
            }

            // tag007
            if (panic.tag007) {
              // panic.tag007
              document.getElementById("tag007red").style.opacity = "1";
              document.getElementById("tag007green").style.opacity = "0";
              document.getElementById("tag007white").style.opacity = "0";
              document.getElementById("panicbuttontag007").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag007.panic += 1;
              this.tag007Button += 1;

              if (panic.tag007.room === "RECEPTION") {
                document.getElementById("panicreceptiontag007").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "none";
                document.getElementById("panichrofficetag007").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "none";
              } else if (panic.tag007.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag007").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "none";
                document.getElementById("panichrofficetag007").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "none";
              } else if (panic.tag007.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag007").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "block";
                document.getElementById("panichrofficetag007").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "none";
              } else if (panic.tag007.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag007").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "none";
                document.getElementById("panichrofficetag007").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "none";
              } else if (panic.tag007.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag007").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "none";
                document.getElementById("panichrofficetag007").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "none";
              } else if (panic.tag007.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag007").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag007"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag007"
                ).style.display = "none";
                document.getElementById("panichrofficetag007").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag007"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag007"
                ).style.display = "block";
              }

              // map controller
              if (this.tag007.panic > 0 && this.tag007.floor === "Ground") {
                document.getElementById("tag007gred").style.display = "block";
                document.getElementById("tag007gblue").style.display = "none";
                document.getElementById("tag007f1red").style.display = "none";
                document.getElementById("tag007f1blue").style.display = "none";
              } else if (
                this.tag007.panic > 0 &&
                this.tag007.floor === "First"
              ) {
                document.getElementById("tag007f1red").style.display = "block";
                document.getElementById("tag007f1blue").style.display = "none";
                document.getElementById("tag007gred").style.display = "none";
                document.getElementById("tag007gblue").style.display = "none";
              }
            }

            // tag008
            if (panic.tag008) {
              // panic.tag008
              document.getElementById("tag008red").style.opacity = "1";
              document.getElementById("tag008green").style.opacity = "0";
              document.getElementById("tag008white").style.opacity = "0";
              document.getElementById("panicbuttontag008").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag008.panic += 1;
              this.tag008Button += 1;

              if (panic.tag008.room === "RECEPTION") {
                document.getElementById("panicreceptiontag008").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "none";
                document.getElementById("panichrofficetag008").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "none";
              } else if (panic.tag008.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag008").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "none";
                document.getElementById("panichrofficetag008").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "none";
              } else if (panic.tag008.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag008").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "block";
                document.getElementById("panichrofficetag008").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "none";
              } else if (panic.tag008.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag008").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "none";
                document.getElementById("panichrofficetag008").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "none";
              } else if (panic.tag008.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag008").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "none";
                document.getElementById("panichrofficetag008").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "none";
              } else if (panic.tag008.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag008").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag008"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag008"
                ).style.display = "none";
                document.getElementById("panichrofficetag008").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag008"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag008"
                ).style.display = "block";
              }

              // map controller
              if (this.tag008.panic > 0 && this.tag008.floor === "Ground") {
                document.getElementById("tag008gred").style.display = "block";
                document.getElementById("tag008gblue").style.display = "none";
                document.getElementById("tag008f1red").style.display = "none";
                document.getElementById("tag008f1blue").style.display = "none";
              } else if (
                this.tag008.panic > 0 &&
                this.tag008.floor === "First"
              ) {
                document.getElementById("tag008f1red").style.display = "block";
                document.getElementById("tag008f1blue").style.display = "none";
                document.getElementById("tag008gred").style.display = "none";
                document.getElementById("tag008gblue").style.display = "none";
              }
            }

            // tag009
            if (panic.tag009) {
              // panic.tag009
              document.getElementById("tag009red").style.opacity = "1";
              document.getElementById("tag009green").style.opacity = "0";
              document.getElementById("tag009white").style.opacity = "0";
              document.getElementById("panicbuttontag009").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag009.panic += 1;
              this.tag009Button += 1;

              if (panic.tag009.room === "RECEPTION") {
                document.getElementById("panicreceptiontag009").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "none";
                document.getElementById("panichrofficetag009").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "none";
              } else if (panic.tag009.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag009").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "none";
                document.getElementById("panichrofficetag009").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "none";
              } else if (panic.tag009.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag009").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "block";
                document.getElementById("panichrofficetag009").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "none";
              } else if (panic.tag009.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag009").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "none";
                document.getElementById("panichrofficetag009").style.display =
                  "block";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "none";
              } else if (panic.tag009.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag009").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "none";
                document.getElementById("panichrofficetag009").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "none";
              } else if (panic.tag009.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag009").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag009"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag009"
                ).style.display = "none";
                document.getElementById("panichrofficetag009").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag009"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag009"
                ).style.display = "block";
              }

              // map controller
              if (this.tag009.panic > 0 && this.tag009.floor === "Ground") {
                document.getElementById("tag009gred").style.display = "block";
                document.getElementById("tag009gblue").style.display = "none";
                document.getElementById("tag009f1red").style.display = "none";
                document.getElementById("tag009f1blue").style.display = "none";
              } else if (
                this.tag009.panic > 0 &&
                this.tag009.floor === "First"
              ) {
                document.getElementById("tag009f1red").style.display = "block";
                document.getElementById("tag009f1blue").style.display = "none";
                document.getElementById("tag009gred").style.display = "none";
                document.getElementById("tag009gblue").style.display = "none";
              }
            }

            // tag010
            if (panic.tag010) {
              // panic.tag010
              document.getElementById("tag010red").style.opacity = "1";
              document.getElementById("tag010green").style.opacity = "0";
              document.getElementById("tag010white").style.opacity = "0";
              document.getElementById("panicbuttontag010").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag010.panic += 1;
              this.tag010Button += 1;

              if (panic.tag010.room === "RECEPTION") {
                document.getElementById("panicreceptiontag010").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "none";
                document.getElementById("panichrofficetag010").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "none";
              } else if (panic.tag010.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag010").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "none";
                document.getElementById("panichrofficetag010").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "none";
              } else if (panic.tag010.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag010").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "block";
                document.getElementById("panichrofficetag010").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "none";
              } else if (panic.tag010.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag010").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "none";
                document.getElementById("panichrofficetag010").style.display =
                  "block";
                //console.log(document.getElementById("panichrofficetag010").style.display);
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "none";
              } else if (panic.tag010.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag010").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "none";
                document.getElementById("panichrofficetag010").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "none";
              } else if (panic.tag010.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag010").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag010"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag010"
                ).style.display = "none";
                document.getElementById("panichrofficetag010").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag010"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag010"
                ).style.display = "block";
              }

              // map controller
              if (this.tag010.panic > 0 && this.tag010.floor === "Ground") {
                document.getElementById("tag010gred").style.display = "block";
                document.getElementById("tag010gblue").style.display = "none";
                document.getElementById("tag010f1red").style.display = "none";
                document.getElementById("tag010f1blue").style.display = "none";
              } else if (
                this.tag010.panic > 0 &&
                this.tag010.floor === "First"
              ) {
                document.getElementById("tag010f1red").style.display = "block";
                document.getElementById("tag010f1blue").style.display = "none";
                document.getElementById("tag010gred").style.display = "none";
                document.getElementById("tag010gblue").style.display = "none";
              }
            }

            // tag011
            if (panic.tag011) {
              // panic.tag011
              document.getElementById("tag011red").style.opacity = "1";
              document.getElementById("tag011green").style.opacity = "0";
              document.getElementById("tag011white").style.opacity = "0";
              document.getElementById("panicbuttontag011").style.display =
                "block";
              document.getElementById("panicsound").play();

              this.tag011.panic += 1;
              this.tag011Button += 1;

              if (panic.tag011.room === "RECEPTION") {
                document.getElementById("panicreceptiontag011").style.display =
                  "block";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "none";
                document.getElementById("panichrofficetag011").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "none";
              } else if (panic.tag011.room === "GUARD OFFICE") {
                document.getElementById("panicreceptiontag011").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "block";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "none";
                document.getElementById("panichrofficetag011").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "none";
              } else if (panic.tag011.room === "TECHNICAL DEPARTMENT") {
                document.getElementById("panicreceptiontag011").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "block";
                document.getElementById("panichrofficetag011").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "none";
              } else if (panic.tag011.room === "HR OFFICE") {
                document.getElementById("panicreceptiontag011").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "none";
                document.getElementById("panichrofficetag011").style.display =
                  "block";
                //console.log(document.getElementById("panichrofficetag011").style.display);
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "none";
              } else if (panic.tag011.room === "CONFERENCE ROOM") {
                document.getElementById("panicreceptiontag011").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "none";
                document.getElementById("panichrofficetag011").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "block";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "none";
              } else if (panic.tag011.room === "SALES OFFICE") {
                document.getElementById("panicreceptiontag011").style.display =
                  "none";
                document.getElementById(
                  "panicguardsofficetag011"
                ).style.display = "none";
                document.getElementById(
                  "panictechnicaldepartmenttag011"
                ).style.display = "none";
                document.getElementById("panichrofficetag011").style.display =
                  "none";
                document.getElementById(
                  "panicconferenceroomtag011"
                ).style.display = "none";
                document.getElementById(
                  "panicsalesofficetag011"
                ).style.display = "block";
              }

              // map controller
              if (this.tag011.panic > 0 && this.tag011.floor === "Ground") {
                document.getElementById("tag011gred").style.display = "block";
                document.getElementById("tag011gblue").style.display = "none";
                document.getElementById("tag011f1red").style.display = "none";
                document.getElementById("tag011f1blue").style.display = "none";
              } else if (
                this.tag011.panic > 0 &&
                this.tag011.floor === "First"
              ) {
                document.getElementById("tag011f1red").style.display = "block";
                document.getElementById("tag011f1blue").style.display = "none";
                document.getElementById("tag011gred").style.display = "none";
                document.getElementById("tag011gblue").style.display = "none";
              }
            }

            // total
            this.totalStatus();
          });
        }
      });
      // auth
      //   .signInWithEmailAndPassword(this.authEmail, this.authPass)
      //   .then(() => {});
    },
    listenToIndoorLocation: function() {
      // listen to data from firebase
      auth.onAuthStateChanged(user => {
        if (user) {
          var indoorLocationRef = db.ref("indoorlocation");
          indoorLocationRef.on("value", snapshot => {
            var indoorLocation = snapshot.val();

            // tag001
            if (indoorLocation.tag001) {
              this.tag001.name = indoorLocation.tag001.tagHolder;
              this.tag001.room = indoorLocation.tag001.room;
              this.tag001.floor = indoorLocation.tag001.floor;
              this.tag001.presence = indoorLocation.tag001.presence;

              if (this.tag001.panic > 0 && this.tag001Button > 0) {
                if (indoorLocation.tag001.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag001").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "none";
                } else if (indoorLocation.tag001.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag001").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag001.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag001").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "none";
                } else if (indoorLocation.tag001.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag001").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "none";
                } else if (indoorLocation.tag001.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag001").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "none";
                } else if (indoorLocation.tag001.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag001"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag001").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag001"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag001"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag001.panic === 0 && this.tag001Button === 0) {
                if (this.tag001.presence === 0) {
                  document.getElementById("tag001red").style.opacity = "0";
                  document.getElementById("tag001green").style.opacity = "0";
                  document.getElementById("tag001white").style.opacity = "1";
                } else if (this.tag001.presence === 1) {
                  document.getElementById("tag001red").style.opacity = "0";
                  document.getElementById("tag001green").style.opacity = "1";
                  document.getElementById("tag001white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag001.panic > 0 && this.tag001.floor === "Ground") {
                document.getElementById("tag001gred").style.display = "block";
                document.getElementById("tag001f1red").style.display = "none";
              } else if (
                this.tag001.panic > 0 &&
                this.tag001.floor === "First"
              ) {
                document.getElementById("tag001f1red").style.display = "block";
                document.getElementById("tag001gred").style.display = "none";
              }
            }

            // tag002
            if (indoorLocation.tag002) {
              this.tag002.name = indoorLocation.tag002.tagHolder;
              this.tag002.room = indoorLocation.tag002.room;
              this.tag002.floor = indoorLocation.tag002.floor;
              this.tag002.presence = indoorLocation.tag002.presence;

              if (this.tag002.panic > 0 && this.tag002Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag002.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag002").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "none";
                } else if (indoorLocation.tag002.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag002").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag002.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag002").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "none";
                } else if (indoorLocation.tag002.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag002").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "none";
                } else if (indoorLocation.tag002.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag002").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "none";
                } else if (indoorLocation.tag002.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag002"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag002").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag002"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag002"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag002.panic === 0 && this.tag002Button === 0) {
                //console.log('我被执行了');
                if (this.tag002.presence === 0) {
                  document.getElementById("tag002red").style.opacity = "0";
                  document.getElementById("tag002green").style.opacity = "0";
                  document.getElementById("tag002white").style.opacity = "1";
                } else if (this.tag002.presence === 1) {
                  document.getElementById("tag002red").style.opacity = "0";
                  document.getElementById("tag002green").style.opacity = "1";
                  document.getElementById("tag002white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag002.panic > 0 && this.tag002.floor === "Ground") {
                document.getElementById("tag002gred").style.display = "block";
                document.getElementById("tag002gblue").style.display = "none";
                document.getElementById("tag002f1red").style.display = "none";
                document.getElementById("tag002f1blue").style.display = "none";
              } else if (
                this.tag002.panic > 0 &&
                this.tag002.floor === "First"
              ) {
                document.getElementById("tag002f1red").style.display = "block";
                document.getElementById("tag002f1blue").style.display = "none";
                document.getElementById("tag002gred").style.display = "none";
                document.getElementById("tag002gblue").style.display = "none";
              }
            }

            // tag003
            if (indoorLocation.tag003) {
              this.tag003.name = indoorLocation.tag003.tagHolder;
              this.tag003.room = indoorLocation.tag003.room;
              this.tag003.floor = indoorLocation.tag003.floor;
              this.tag003.presence = indoorLocation.tag003.presence;

              if (this.tag003.panic > 0 && this.tag003Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag003.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag003").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "none";
                } else if (indoorLocation.tag003.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag003").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag003.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag003").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "none";
                } else if (indoorLocation.tag003.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag003").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "none";
                } else if (indoorLocation.tag003.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag003").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "none";
                } else if (indoorLocation.tag003.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag003"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag003").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag003"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag003"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag003.panic === 0 && this.tag003Button === 0) {
                //console.log('我被执行了');
                if (this.tag003.presence === 0) {
                  document.getElementById("tag003red").style.opacity = "0";
                  document.getElementById("tag003green").style.opacity = "0";
                  document.getElementById("tag003white").style.opacity = "1";
                } else if (this.tag003.presence === 1) {
                  document.getElementById("tag003red").style.opacity = "0";
                  document.getElementById("tag003green").style.opacity = "1";
                  document.getElementById("tag003white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag003.panic > 0 && this.tag003.floor === "Ground") {
                document.getElementById("tag003gred").style.display = "block";
                document.getElementById("tag003gblue").style.display = "none";
                document.getElementById("tag003f1red").style.display = "none";
                document.getElementById("tag003f1blue").style.display = "none";
              } else if (
                this.tag003.panic > 0 &&
                this.tag003.floor === "First"
              ) {
                document.getElementById("tag003f1red").style.display = "block";
                document.getElementById("tag003f1blue").style.display = "none";
                document.getElementById("tag003gred").style.display = "none";
                document.getElementById("tag003gblue").style.display = "none";
              }
            }

            // tag004
            if (indoorLocation.tag004) {
              this.tag004.name = indoorLocation.tag004.tagHolder;
              this.tag004.room = indoorLocation.tag004.room;
              this.tag004.floor = indoorLocation.tag004.floor;
              this.tag004.presence = indoorLocation.tag004.presence;

              if (this.tag004.panic > 0 && this.tag004Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag004.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag004").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "none";
                } else if (indoorLocation.tag004.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag004").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag004.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag004").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "none";
                } else if (indoorLocation.tag004.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag004").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "none";
                } else if (indoorLocation.tag004.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag004").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "none";
                } else if (indoorLocation.tag004.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag004"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag004").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag004"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag004"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag004.panic === 0 && this.tag004Button === 0) {
                //console.log('我被执行了');
                if (this.tag004.presence === 0) {
                  document.getElementById("tag004red").style.opacity = "0";
                  document.getElementById("tag004green").style.opacity = "0";
                  document.getElementById("tag004white").style.opacity = "1";
                } else if (this.tag004.presence === 1) {
                  document.getElementById("tag004red").style.opacity = "0";
                  document.getElementById("tag004green").style.opacity = "1";
                  document.getElementById("tag004white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag004.panic > 0 && this.tag004.floor === "Ground") {
                document.getElementById("tag004gred").style.display = "block";
                document.getElementById("tag004gblue").style.display = "none";
                document.getElementById("tag004f1red").style.display = "none";
                document.getElementById("tag004f1blue").style.display = "none";
              } else if (
                this.tag004.panic > 0 &&
                this.tag004.floor === "First"
              ) {
                document.getElementById("tag004f1red").style.display = "block";
                document.getElementById("tag004f1blue").style.display = "none";
                document.getElementById("tag004gred").style.display = "none";
                document.getElementById("tag004gblue").style.display = "none";
              }
            }

            // tag005
            if (indoorLocation.tag005) {
              this.tag005.name = indoorLocation.tag005.tagHolder;
              this.tag005.room = indoorLocation.tag005.room;
              this.tag005.floor = indoorLocation.tag005.floor;
              this.tag005.presence = indoorLocation.tag005.presence;

              if (this.tag005.panic > 0 && this.tag005Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag005.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag005").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "none";
                } else if (indoorLocation.tag005.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag005").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag005.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag005").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "none";
                } else if (indoorLocation.tag005.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag005").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "none";
                } else if (indoorLocation.tag005.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag005").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "none";
                } else if (indoorLocation.tag005.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag005"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag005").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag005"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag005"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag005.panic === 0 && this.tag005Button === 0) {
                //console.log('我被执行了');
                if (this.tag005.presence === 0) {
                  document.getElementById("tag005red").style.opacity = "0";
                  document.getElementById("tag005green").style.opacity = "0";
                  document.getElementById("tag005white").style.opacity = "1";
                } else if (this.tag005.presence === 1) {
                  document.getElementById("tag005red").style.opacity = "0";
                  document.getElementById("tag005green").style.opacity = "1";
                  document.getElementById("tag005white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag005.panic > 0 && this.tag005.floor === "Ground") {
                document.getElementById("tag005gred").style.display = "block";
                document.getElementById("tag005gblue").style.display = "none";
                document.getElementById("tag005f1red").style.display = "none";
                document.getElementById("tag005f1blue").style.display = "none";
              } else if (
                this.tag005.panic > 0 &&
                this.tag005.floor === "First"
              ) {
                document.getElementById("tag005f1red").style.display = "block";
                document.getElementById("tag005f1blue").style.display = "none";
                document.getElementById("tag005gred").style.display = "none";
                document.getElementById("tag005gblue").style.display = "none";
              }
            }

            // tag006
            if (indoorLocation.tag006) {
              this.tag006.name = indoorLocation.tag006.tagHolder;
              this.tag006.room = indoorLocation.tag006.room;
              this.tag006.floor = indoorLocation.tag006.floor;
              this.tag006.presence = indoorLocation.tag006.presence;

              if (this.tag006.panic > 0 && this.tag006Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag006.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag006").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "none";
                } else if (indoorLocation.tag006.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag006").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag006.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag006").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "none";
                } else if (indoorLocation.tag006.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag006").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "none";
                } else if (indoorLocation.tag006.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag006").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "none";
                } else if (indoorLocation.tag006.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag006"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag006").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag006"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag006"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag006.panic === 0 && this.tag006Button === 0) {
                //console.log('我被执行了');
                if (this.tag006.presence === 0) {
                  document.getElementById("tag006red").style.opacity = "0";
                  document.getElementById("tag006green").style.opacity = "0";
                  document.getElementById("tag006white").style.opacity = "1";
                } else if (this.tag006.presence === 1) {
                  document.getElementById("tag006red").style.opacity = "0";
                  document.getElementById("tag006green").style.opacity = "1";
                  document.getElementById("tag006white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag006.panic > 0 && this.tag006.floor === "Ground") {
                document.getElementById("tag006gred").style.display = "block";
                document.getElementById("tag006gblue").style.display = "none";
                document.getElementById("tag006f1red").style.display = "none";
                document.getElementById("tag006f1blue").style.display = "none";
              } else if (
                this.tag006.panic > 0 &&
                this.tag006.floor === "First"
              ) {
                document.getElementById("tag006f1red").style.display = "block";
                document.getElementById("tag006f1blue").style.display = "none";
                document.getElementById("tag006gred").style.display = "none";
                document.getElementById("tag006gblue").style.display = "none";
              }
            }

            // tag007
            if (indoorLocation.tag007) {
              this.tag007.name = indoorLocation.tag007.tagHolder;
              this.tag007.room = indoorLocation.tag007.room;
              this.tag007.floor = indoorLocation.tag007.floor;
              this.tag007.presence = indoorLocation.tag007.presence;

              if (this.tag007.panic > 0 && this.tag007Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag007.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag007").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "none";
                } else if (indoorLocation.tag007.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag007").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag007.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag007").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "none";
                } else if (indoorLocation.tag007.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag007").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "none";
                } else if (indoorLocation.tag007.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag007").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "none";
                } else if (indoorLocation.tag007.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag007"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag007").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag007"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag007"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag007.panic === 0 && this.tag007Button === 0) {
                //console.log('我被执行了');
                if (this.tag007.presence === 0) {
                  document.getElementById("tag007red").style.opacity = "0";
                  document.getElementById("tag007green").style.opacity = "0";
                  document.getElementById("tag007white").style.opacity = "1";
                } else if (this.tag007.presence === 1) {
                  document.getElementById("tag007red").style.opacity = "0";
                  document.getElementById("tag007green").style.opacity = "1";
                  document.getElementById("tag007white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag007.panic > 0 && this.tag007.floor === "Ground") {
                document.getElementById("tag007gred").style.display = "block";
                document.getElementById("tag007gblue").style.display = "none";
                document.getElementById("tag007f1red").style.display = "none";
                document.getElementById("tag007f1blue").style.display = "none";
              } else if (
                this.tag007.panic > 0 &&
                this.tag007.floor === "First"
              ) {
                document.getElementById("tag007f1red").style.display = "block";
                document.getElementById("tag007f1blue").style.display = "none";
                document.getElementById("tag007gred").style.display = "none";
                document.getElementById("tag007gblue").style.display = "none";
              }
            }

            // tag008
            if (indoorLocation.tag008) {
              this.tag008.name = indoorLocation.tag008.tagHolder;
              this.tag008.room = indoorLocation.tag008.room;
              this.tag008.floor = indoorLocation.tag008.floor;
              this.tag008.presence = indoorLocation.tag008.presence;

              if (this.tag008.panic > 0 && this.tag008Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag008.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag008").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "none";
                } else if (indoorLocation.tag008.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag008").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag008.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag008").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "none";
                } else if (indoorLocation.tag008.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag008").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "none";
                } else if (indoorLocation.tag008.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag008").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "none";
                } else if (indoorLocation.tag008.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag008"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag008").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag008"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag008"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag008.panic === 0 && this.tag008Button === 0) {
                //console.log('我被执行了');
                if (this.tag008.presence === 0) {
                  document.getElementById("tag008red").style.opacity = "0";
                  document.getElementById("tag008green").style.opacity = "0";
                  document.getElementById("tag008white").style.opacity = "1";
                } else if (this.tag008.presence === 1) {
                  document.getElementById("tag008red").style.opacity = "0";
                  document.getElementById("tag008green").style.opacity = "1";
                  document.getElementById("tag008white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag008.panic > 0 && this.tag008.floor === "Ground") {
                document.getElementById("tag008gred").style.display = "block";
                document.getElementById("tag008gblue").style.display = "none";
                document.getElementById("tag008f1red").style.display = "none";
                document.getElementById("tag008f1blue").style.display = "none";
              } else if (
                this.tag008.panic > 0 &&
                this.tag008.floor === "First"
              ) {
                document.getElementById("tag008f1red").style.display = "block";
                document.getElementById("tag008f1blue").style.display = "none";
                document.getElementById("tag008gred").style.display = "none";
                document.getElementById("tag008gblue").style.display = "none";
              }
            }

            // tag009
            if (indoorLocation.tag009) {
              this.tag009.name = indoorLocation.tag009.tagHolder;
              this.tag009.room = indoorLocation.tag009.room;
              this.tag009.floor = indoorLocation.tag009.floor;
              this.tag009.presence = indoorLocation.tag009.presence;

              if (this.tag009.panic > 0 && this.tag009Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag009.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag009").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "none";
                } else if (indoorLocation.tag009.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag009").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag009.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag009").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "none";
                } else if (indoorLocation.tag009.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag009").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "none";
                } else if (indoorLocation.tag009.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag009").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "none";
                } else if (indoorLocation.tag009.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag009"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag009").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag009"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag009"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag009.panic === 0 && this.tag009Button === 0) {
                //console.log('我被执行了');
                if (this.tag009.presence === 0) {
                  document.getElementById("tag009red").style.opacity = "0";
                  document.getElementById("tag009green").style.opacity = "0";
                  document.getElementById("tag009white").style.opacity = "1";
                } else if (this.tag009.presence === 1) {
                  document.getElementById("tag009red").style.opacity = "0";
                  document.getElementById("tag009green").style.opacity = "1";
                  document.getElementById("tag009white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag009.panic > 0 && this.tag009.floor === "Ground") {
                document.getElementById("tag009gred").style.display = "block";
                document.getElementById("tag009gblue").style.display = "none";
                document.getElementById("tag009f1red").style.display = "none";
                document.getElementById("tag009f1blue").style.display = "none";
              } else if (
                this.tag009.panic > 0 &&
                this.tag009.floor === "First"
              ) {
                document.getElementById("tag009f1red").style.display = "block";
                document.getElementById("tag009f1blue").style.display = "none";
                document.getElementById("tag009gred").style.display = "none";
                document.getElementById("tag009gblue").style.display = "none";
              }
            }

            // tag010
            if (indoorLocation.tag010) {
              this.tag010.name = indoorLocation.tag010.tagHolder;
              this.tag010.room = indoorLocation.tag010.room;
              this.tag010.floor = indoorLocation.tag010.floor;
              this.tag010.presence = indoorLocation.tag010.presence;

              if (this.tag010.panic > 0 && this.tag010Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag010.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag010").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "none";
                } else if (indoorLocation.tag010.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag010").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag010.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag010").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "none";
                } else if (indoorLocation.tag010.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag010").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "none";
                } else if (indoorLocation.tag010.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag010").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "none";
                } else if (indoorLocation.tag010.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag010"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag010").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag010"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag010"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag010.panic === 0 && this.tag010Button === 0) {
                //console.log('我被执行了');
                if (this.tag010.presence === 0) {
                  document.getElementById("tag010red").style.opacity = "0";
                  document.getElementById("tag010green").style.opacity = "0";
                  document.getElementById("tag010white").style.opacity = "1";
                } else if (this.tag010.presence === 1) {
                  document.getElementById("tag010red").style.opacity = "0";
                  document.getElementById("tag010green").style.opacity = "1";
                  document.getElementById("tag010white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag010.panic > 0 && this.tag010.floor === "Ground") {
                document.getElementById("tag010gred").style.display = "block";
                document.getElementById("tag010gblue").style.display = "none";
                document.getElementById("tag010f1red").style.display = "none";
                document.getElementById("tag010f1blue").style.display = "none";
              } else if (
                this.tag010.panic > 0 &&
                this.tag010.floor === "First"
              ) {
                document.getElementById("tag010f1red").style.display = "block";
                document.getElementById("tag010f1blue").style.display = "none";
                document.getElementById("tag010gred").style.display = "none";
                document.getElementById("tag010gblue").style.display = "none";
              }
            }

            // tag011

            if (indoorLocation.tag011) {
              this.tag011.name = indoorLocation.tag011.tagHolder;
              this.tag011.room = indoorLocation.tag011.room;
              this.tag011.floor = indoorLocation.tag011.floor;
              this.tag011.presence = indoorLocation.tag011.presence;

              if (this.tag011.panic > 0 && this.tag011Button > 0) {
                // 在什么地方就显示在什么地方
                if (indoorLocation.tag011.room === "RECEPTION") {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "block";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag011").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "none";
                } else if (indoorLocation.tag011.room === "GUARD OFFICE") {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "block";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag011").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "none";
                } else if (
                  indoorLocation.tag011.room === "TECHNICAL DEPARTMENT"
                ) {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "block";
                  document.getElementById("panichrofficetag011").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "none";
                } else if (indoorLocation.tag011.room === "HR OFFICE") {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag011").style.display =
                    "block";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "none";
                } else if (indoorLocation.tag011.room === "CONFERENCE ROOM") {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag011").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "block";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "none";
                } else if (indoorLocation.tag011.room === "SALES OFFICE") {
                  document.getElementById(
                    "panicreceptiontag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicguardsofficetag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panictechnicaldepartmenttag011"
                  ).style.display = "none";
                  document.getElementById("panichrofficetag011").style.display =
                    "none";
                  document.getElementById(
                    "panicconferenceroomtag011"
                  ).style.display = "none";
                  document.getElementById(
                    "panicsalesofficetag011"
                  ).style.display = "block";
                }
                // 表示前面没有 PANIC 或者 PANIC 被处理了
              } else if (this.tag011.panic === 0 && this.tag011Button === 0) {
                //console.log('我被执行了');
                if (this.tag011.presence === 0) {
                  document.getElementById("tag011red").style.opacity = "0";
                  document.getElementById("tag011green").style.opacity = "0";
                  document.getElementById("tag011white").style.opacity = "1";
                } else if (this.tag011.presence === 1) {
                  document.getElementById("tag011red").style.opacity = "0";
                  document.getElementById("tag011green").style.opacity = "1";
                  document.getElementById("tag011white").style.opacity = "0";
                }
              }

              // map controller
              if (this.tag011.panic > 0 && this.tag011.floor === "Ground") {
                document.getElementById("tag011gred").style.display = "block";
                document.getElementById("tag011gblue").style.display = "none";
                document.getElementById("tag011f1red").style.display = "none";
                document.getElementById("tag011f1blue").style.display = "none";
              } else if (
                this.tag011.panic > 0 &&
                this.tag011.floor === "First"
              ) {
                document.getElementById("tag011f1red").style.display = "block";
                document.getElementById("tag011f1blue").style.display = "none";
                document.getElementById("tag011gred").style.display = "none";
                document.getElementById("tag011gblue").style.display = "none";
              }
            }

            // total
            this.totalStatus();
          });
        }
      });
      // auth
      //   .signInWithEmailAndPassword(this.authEmail, this.authPass)
      //   .then(() => {});
    },
    totalStatus: function() {
      this.totalAbsence =
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag001white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag002white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag003white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag004white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag005white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag006white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag007white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag008white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag009white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag010white"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag011white"))
            .getPropertyValue("opacity")
        );

      this.totalPresence =
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag001green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag002green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag003green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag004green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag005green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag006green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag007green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag008green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag009green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag010green"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag011green"))
            .getPropertyValue("opacity")
        );

      this.totalPanic =
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag001red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag002red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag003red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag004red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag005red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag006red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag007red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag008red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag009red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag010red"))
            .getPropertyValue("opacity")
        ) +
        parseInt(
          window
            .getComputedStyle(document.getElementById("tag011red"))
            .getPropertyValue("opacity")
        );
    },
    cancelPanicTag001: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag001").remove();
      // flash maker
      document.getElementById("panicreceptiontag001").style.display = "none";
      document.getElementById("panicguardsofficetag001").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag001").style.display =
        "none";
      document.getElementById("panichrofficetag001").style.display = "none";
      document.getElementById("panicconferenceroomtag001").style.display =
        "none";
      document.getElementById("panicsalesofficetag001").style.display = "none";

      // status
      this.tag001.panic = 0;
      this.tag001Button = 0;
      document.getElementById("tag001red").style.opacity = "0";
      document.getElementById(
        "tag001green"
      ).style.opacity = this.tag001.presence;
      document.getElementById("tag001white").style.opacity =
        1 - this.tag001.presence;

      // button
      document.getElementById("panicbuttontag001").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag001gred").style.display = "none";
      document.getElementById("tag001gblue").style.display = "block";
      document.getElementById("tag001f1red").style.display = "none";
      document.getElementById("tag001f1blue").style.display = "block";
    },
    cancelPanicTag002: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag002").remove();
      // flash maker
      document.getElementById("panicreceptiontag002").style.display = "none";
      document.getElementById("panicguardsofficetag002").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag002").style.display =
        "none";
      document.getElementById("panichrofficetag002").style.display = "none";
      document.getElementById("panicconferenceroomtag002").style.display =
        "none";
      document.getElementById("panicsalesofficetag002").style.display = "none";

      // status
      this.tag002.panic = 0;
      this.tag002Button = 0;
      document.getElementById("tag002red").style.opacity = "0";
      document.getElementById(
        "tag002green"
      ).style.opacity = this.tag002.presence;
      document.getElementById("tag002white").style.opacity =
        1 - this.tag002.presence;

      // button
      document.getElementById("panicbuttontag002").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag002gred").style.display = "none";
      document.getElementById("tag002gblue").style.display = "block";
      document.getElementById("tag002f1red").style.display = "none";
      document.getElementById("tag002f1blue").style.display = "block";
    },
    cancelPanicTag003: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag003").remove();
      // flash maker
      document.getElementById("panicreceptiontag003").style.display = "none";
      document.getElementById("panicguardsofficetag003").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag003").style.display =
        "none";
      document.getElementById("panichrofficetag003").style.display = "none";
      document.getElementById("panicconferenceroomtag003").style.display =
        "none";
      document.getElementById("panicsalesofficetag003").style.display = "none";

      // status
      this.tag003.panic = 0;
      this.tag003Button = 0;
      document.getElementById("tag003red").style.opacity = "0";
      document.getElementById(
        "tag003green"
      ).style.opacity = this.tag003.presence;
      document.getElementById("tag003white").style.opacity =
        1 - this.tag003.presence;

      // button
      document.getElementById("panicbuttontag003").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag003gred").style.display = "none";
      document.getElementById("tag003gblue").style.display = "block";
      document.getElementById("tag003f1red").style.display = "none";
      document.getElementById("tag003f1blue").style.display = "block";
    },
    cancelPanicTag004: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag004").remove();
      // flash maker
      document.getElementById("panicreceptiontag004").style.display = "none";
      document.getElementById("panicguardsofficetag004").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag004").style.display =
        "none";
      document.getElementById("panichrofficetag004").style.display = "none";
      document.getElementById("panicconferenceroomtag004").style.display =
        "none";
      document.getElementById("panicsalesofficetag004").style.display = "none";

      // status
      this.tag004.panic = 0;
      this.tag004Button = 0;
      document.getElementById("tag004red").style.opacity = "0";
      document.getElementById(
        "tag004green"
      ).style.opacity = this.tag004.presence;
      document.getElementById("tag004white").style.opacity =
        1 - this.tag004.presence;

      // button
      document.getElementById("panicbuttontag004").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag004gred").style.display = "none";
      document.getElementById("tag004gblue").style.display = "block";
      document.getElementById("tag004f1red").style.display = "none";
      document.getElementById("tag004f1blue").style.display = "block";
    },
    cancelPanicTag005: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag005").remove();
      // flash maker
      document.getElementById("panicreceptiontag005").style.display = "none";
      document.getElementById("panicguardsofficetag005").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag005").style.display =
        "none";
      document.getElementById("panichrofficetag005").style.display = "none";
      document.getElementById("panicconferenceroomtag005").style.display =
        "none";
      document.getElementById("panicsalesofficetag005").style.display = "none";

      // status
      this.tag005.panic = 0;
      this.tag005Button = 0;
      document.getElementById("tag005red").style.opacity = "0";
      document.getElementById(
        "tag005green"
      ).style.opacity = this.tag005.presence;
      document.getElementById("tag005white").style.opacity =
        1 - this.tag005.presence;

      // button
      document.getElementById("panicbuttontag005").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag005gred").style.display = "none";
      document.getElementById("tag005gblue").style.display = "block";
      document.getElementById("tag005f1red").style.display = "none";
      document.getElementById("tag005f1blue").style.display = "block";
    },
    cancelPanicTag006: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag006").remove();
      // flash maker
      document.getElementById("panicreceptiontag006").style.display = "none";
      document.getElementById("panicguardsofficetag006").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag006").style.display =
        "none";
      document.getElementById("panichrofficetag006").style.display = "none";
      document.getElementById("panicconferenceroomtag006").style.display =
        "none";
      document.getElementById("panicsalesofficetag006").style.display = "none";

      // status
      this.tag006.panic = 0;
      this.tag006Button = 0;
      document.getElementById("tag006red").style.opacity = "0";
      document.getElementById(
        "tag006green"
      ).style.opacity = this.tag006.presence;
      document.getElementById("tag006white").style.opacity =
        1 - this.tag006.presence;

      // button
      document.getElementById("panicbuttontag006").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag006gred").style.display = "none";
      document.getElementById("tag006gblue").style.display = "block";
      document.getElementById("tag006f1red").style.display = "none";
      document.getElementById("tag006f1blue").style.display = "block";
    },
    cancelPanicTag007: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag007").remove();
      // flash maker
      document.getElementById("panicreceptiontag007").style.display = "none";
      document.getElementById("panicguardsofficetag007").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag007").style.display =
        "none";
      document.getElementById("panichrofficetag007").style.display = "none";
      document.getElementById("panicconferenceroomtag007").style.display =
        "none";
      document.getElementById("panicsalesofficetag007").style.display = "none";

      // status
      this.tag007.panic = 0;
      this.tag007Button = 0;
      document.getElementById("tag007red").style.opacity = "0";
      document.getElementById(
        "tag007green"
      ).style.opacity = this.tag007.presence;
      document.getElementById("tag007white").style.opacity =
        1 - this.tag007.presence;

      // button
      document.getElementById("panicbuttontag007").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag007gred").style.display = "none";
      document.getElementById("tag007gblue").style.display = "block";
      document.getElementById("tag007f1red").style.display = "none";
      document.getElementById("tag007f1blue").style.display = "block";
    },
    cancelPanicTag008: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag008").remove();
      // flash maker
      document.getElementById("panicreceptiontag008").style.display = "none";
      document.getElementById("panicguardsofficetag008").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag008").style.display =
        "none";
      document.getElementById("panichrofficetag008").style.display = "none";
      document.getElementById("panicconferenceroomtag008").style.display =
        "none";
      document.getElementById("panicsalesofficetag008").style.display = "none";

      // status
      this.tag008.panic = 0;
      this.tag008Button = 0;
      document.getElementById("tag008red").style.opacity = "0";
      document.getElementById(
        "tag008green"
      ).style.opacity = this.tag008.presence;
      document.getElementById("tag008white").style.opacity =
        1 - this.tag008.presence;

      // button
      document.getElementById("panicbuttontag008").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag008gred").style.display = "none";
      document.getElementById("tag008gblue").style.display = "block";
      document.getElementById("tag008f1red").style.display = "none";
      document.getElementById("tag008f1blue").style.display = "block";
    },
    cancelPanicTag009: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag009").remove();
      // flash maker
      document.getElementById("panicreceptiontag009").style.display = "none";
      document.getElementById("panicguardsofficetag009").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag009").style.display =
        "none";
      document.getElementById("panichrofficetag009").style.display = "none";
      document.getElementById("panicconferenceroomtag009").style.display =
        "none";
      document.getElementById("panicsalesofficetag009").style.display = "none";

      // status
      this.tag009.panic = 0;
      this.tag009Button = 0;
      document.getElementById("tag009red").style.opacity = "0";
      document.getElementById(
        "tag009green"
      ).style.opacity = this.tag009.presence;
      document.getElementById("tag009white").style.opacity =
        1 - this.tag009.presence;

      // button
      document.getElementById("panicbuttontag009").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag009gred").style.display = "none";
      document.getElementById("tag009gblue").style.display = "block";
      document.getElementById("tag009f1red").style.display = "none";
      document.getElementById("tag009f1blue").style.display = "block";
    },
    cancelPanicTag010: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag010").remove();
      // flash maker
      //console.log('run 10');
      document.getElementById("panicreceptiontag010").style.display = "none";
      document.getElementById("panicguardsofficetag010").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag010").style.display =
        "none";
      document.getElementById("panichrofficetag010").style.display = "none";
      document.getElementById("panicconferenceroomtag010").style.display =
        "none";
      document.getElementById("panicsalesofficetag010").style.display = "none";

      // status
      this.tag010.panic = 0;
      this.tag010Button = 0;
      document.getElementById("tag010red").style.opacity = "0";
      document.getElementById(
        "tag010green"
      ).style.opacity = this.tag010.presence;
      document.getElementById("tag010white").style.opacity =
        1 - this.tag010.presence;

      // button
      document.getElementById("panicbuttontag010").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag010gred").style.display = "none";
      document.getElementById("tag010gblue").style.display = "block";
      document.getElementById("tag010f1red").style.display = "none";
      document.getElementById("tag010f1blue").style.display = "block";
    },
    cancelPanicTag011: function() {
      // delete panic from firebase
      db.ref("clientpanic/tag011").remove();
      // flash maker

      document.getElementById("panicreceptiontag011").style.display = "none";
      document.getElementById("panicguardsofficetag011").style.display = "none";
      document.getElementById("panictechnicaldepartmenttag011").style.display =
        "none";
      document.getElementById("panichrofficetag011").style.display = "none";
      document.getElementById("panicconferenceroomtag011").style.display =
        "none";
      document.getElementById("panicsalesofficetag011").style.display = "none";

      // status
      this.tag011.panic = 0;
      this.tag011Button = 0;
      document.getElementById("tag011red").style.opacity = "0";
      document.getElementById(
        "tag011green"
      ).style.opacity = this.tag011.presence;
      document.getElementById("tag011white").style.opacity =
        1 - this.tag011.presence;

      // button
      document.getElementById("panicbuttontag011").style.display = "none";

      //total
      this.totalStatus();

      //sound
      if (this.totalPanic === 0) {
        document.getElementById("panicsound").pause();
      } else {
        document.getElementById("panicsound").play();
      }

      // map controller
      document.getElementById("tag011gred").style.display = "none";
      document.getElementById("tag011gblue").style.display = "block";
      document.getElementById("tag011f1red").style.display = "none";
      document.getElementById("tag011f1blue").style.display = "block";
    }
  },
  destroyed: function() {
    auth.signOut();
  }
};
</script>

<style scoped>
.mapcontroller {
  width: 50px;
  height: 120px;
  position: absolute;
  top: 74px;
  left: 120px;
}

.mapcontrollerg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 40px;
  height: 40px;
}

.mapcontrollerf1 {
  position: absolute;
  top: 60px;
  left: 0px;
  width: 40px;
  height: 40px;
}

#tag001gred {
  display: none;
  z-index: 2;
}
#tag002gred {
  display: none;
  z-index: 2;
}
#tag003gred {
  display: none;
  z-index: 2;
}
#tag004gred {
  display: none;
  z-index: 2;
}
#tag005gred {
  display: none;
  z-index: 2;
}
#tag006gred {
  display: none;
  z-index: 2;
}
#tag007gred {
  display: none;
  z-index: 2;
}
#tag008gred {
  display: none;
  z-index: 2;
}
#tag009gred {
  display: none;
  z-index: 2;
}
#tag010gred {
  display: none;
  z-index: 2;
}
#tag011gred {
  display: none;
  z-index: 2;
}

#tag001gblue {
  display: block;
}
#tag002gblue {
  display: block;
}
#tag003gblue {
  display: block;
}
#tag004gblue {
  display: block;
}
#tag005gblue {
  display: block;
}
#tag006gblue {
  display: block;
}
#tag007gblue {
  display: block;
}
#tag008gblue {
  display: block;
}
#tag009gblue {
  display: block;
}
#tag010gblue {
  display: block;
}
#tag011gblue {
  display: block;
}

#tag001f1red {
  display: none;
  z-index: 2;
}
#tag002f1red {
  display: none;
  z-index: 2;
}
#tag003f1red {
  display: none;
  z-index: 2;
}
#tag004f1red {
  display: none;
  z-index: 2;
}
#tag005f1red {
  display: none;
  z-index: 2;
}
#tag006f1red {
  display: none;
  z-index: 2;
}
#tag007f1red {
  display: none;
  z-index: 2;
}
#tag008f1red {
  display: none;
  z-index: 2;
}
#tag009f1red {
  display: none;
  z-index: 2;
}
#tag010f1red {
  display: none;
  z-index: 2;
}
#tag011f1red {
  display: none;
  z-index: 2;
}

#tag001f1blue {
  display: block;
}
#tag002f1blue {
  display: block;
}
#tag003f1blue {
  display: block;
}
#tag004f1blue {
  display: block;
}
#tag005f1blue {
  display: block;
}
#tag006f1blue {
  display: block;
}
#tag007f1blue {
  display: block;
}
#tag008f1blue {
  display: block;
}
#tag009f1blue {
  display: block;
}
#tag010f1blue {
  display: block;
}
#tag011f1blue {
  display: block;
}

/* floor plan */
.floorplan {
  width: 810px;
  height: 932px;
  position: absolute;
  top: 0px;
  left: 200px;
}

.paniccontainer {
  width: 300px;
  height: auto;
  position: absolute;
  top: 29px;
  left: 1333px;
}

.staff {
  width: 48px;
  height: 80px;
}

.tag001 {
  position: absolute;
  top: 0px;
  left: 0px;
}

#tag001red {
  opacity: 0;
}

#tag001green {
  opacity: 0;
}

#tag001white {
  opacity: 1;
}

#tag002red {
  opacity: 0;
}

#tag002green {
  opacity: 0;
}

#tag002white {
  opacity: 1;
}

#tag003red {
  opacity: 0;
}

#tag003green {
  opacity: 0;
}

#tag003white {
  opacity: 1;
}

#tag004red {
  opacity: 0;
}

#tag004green {
  opacity: 0;
}

#tag004white {
  opacity: 1;
}

#tag005red {
  opacity: 0;
}

#tag005green {
  opacity: 0;
}

#tag005white {
  opacity: 1;
}

#tag006red {
  opacity: 0;
}

#tag006green {
  opacity: 0;
}

#tag006white {
  opacity: 1;
}

#tag007red {
  opacity: 0;
}

#tag007green {
  opacity: 0;
}

#tag007white {
  opacity: 1;
}

#tag008red {
  opacity: 0;
}

#tag008green {
  opacity: 0;
}

#tag008white {
  opacity: 1;
}

#tag009red {
  opacity: 0;
}

#tag009green {
  opacity: 0;
}

#tag009white {
  opacity: 1;
}

#tag010red {
  opacity: 0;
}

#tag010green {
  opacity: 0;
}

#tag010white {
  opacity: 1;
}

#tag011red {
  opacity: 0;
}

#tag011green {
  opacity: 0;
}

#tag011white {
  opacity: 1;
}

.tagtext {
  position: absolute;
  top: 3px;
  left: 60px;
  width: 250px;
  border-bottom: 1px solid lightgray;
}

.panicbutton {
  position: absolute;
  top: 2px;
  left: 320px;
}

#panicbuttontag001 {
  display: none;
}

#panicbuttontag002 {
  display: none;
}

#panicbuttontag003 {
  display: none;
}

#panicbuttontag004 {
  display: none;
}

#panicbuttontag005 {
  display: none;
}

#panicbuttontag006 {
  display: none;
}

#panicbuttontag007 {
  display: none;
}

#panicbuttontag008 {
  display: none;
}

#panicbuttontag009 {
  display: none;
}

#panicbuttontag010 {
  display: none;
}

#panicbuttontag011 {
  display: none;
}

.categoryStatus {
  position: absolute;
  top: 20px;
  left: 1122px;
  z-index: 4;
  width: 364px;
  height: 94px;
  border-bottom: 1px lightgray solid;
}

.totalPresence {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 70px;
  height: 92px;
}

.totalLeft {
  position: absolute;
  top: 0px;
  left: 128px;
}

.totalPanic {
  position: absolute;
  top: 0px;
  left: 256px;
}

.totalPresence img {
  width: 38px;
}

.totalLeft img {
  width: 40px;
}

.totalPanic img {
  width: 40px;
}

.staffstatus {
  width: 415px;
  height: 880px;
  position: absolute;
  top: 120px;
  left: 1062px;
  z-index: 3;
}

.tag001div {
  position: absolute;
  top: 0px;
  left: 0px;
}

.tag002div {
  position: absolute;
  top: 80px;
  left: 0px;
}

.tag003div {
  position: absolute;
  top: 160px;
  left: 0px;
}

.tag004div {
  position: absolute;
  top: 240px;
  left: 0px;
}

.tag005div {
  position: absolute;
  top: 320px;
  left: 0px;
}

.tag006div {
  position: absolute;
  top: 400px;
  left: 0px;
}

.tag007div {
  position: absolute;
  top: 480px;
  left: 0px;
}

.tag008div {
  position: absolute;
  top: 560px;
  left: 0px;
}

.tag009div {
  position: absolute;
  top: 640px;
  left: 0px;
}

.tag010div {
  position: absolute;
  top: 720px;
  left: 0px;
}

.tag011div {
  position: absolute;
  top: 800px;
  left: 0px;
}

.floorplan0 {
  width: 799px;
  height: 485px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.panicreception {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 90px;
  left: 140px;
  z-index: 2;
  display: none;
}

.panicguardsoffice {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 125px;
  left: 640px;
  z-index: 2;
  display: none;
}

.panictechnicaldepartment {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 330px;
  left: 290px;
  z-index: 2;
  display: none;
}

.panichroffice {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 560px;
  left: 135px;
  z-index: 2;
  display: none;
}

.panicconferenceroom {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 730px;
  left: 150px;
  z-index: 2;
  display: none;
}

.panicsalesoffice {
  width: 48px;
  height: 80px;
  position: absolute;
  top: 570px;
  left: 640px;
  z-index: 2;
  display: none;
}

.floorplan1 {
  width: 799px;
  height: 485px;
  position: absolute;
  top: 445px;
  left: 0px;
  z-index: 1;
}

.floorplanmarkeranimation {
  animation-name: example;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}

@keyframes example {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
